import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-3 d-flex" }
const _hoisted_2 = { class: "flex-fill" }

import OperatorApplicationWebRtcCall from "~/operatorApplication/ts/service/webRtc/OperatorApplicationWebRtcCall";
import {computed} from "vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";


const __default__ = {
    name: "NewIncomingWebRtcCall"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let incomingCall = computed(() => OperatorApplicationWebRtcCall.incomingCalls.value[0]);

let incomingCallUserDescrList = computed(() => {
    let users = incomingCall?.value.getCallData()?.users ?? [];
    return users
        .filter(user => !user.isYou)
        .map(user => user.descr)
        .join(", ");
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_unref(incomingCall))
    ? (_openBlock(), _createBlock(_component_el_card, {
        key: 0,
        class: "incoming-call-notification"
      }, {
        default: _withCtx(() => [
          _createVNode(ElCardSection, null, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("h5", null, "Новый входящий звонок", -1)),
              _createElementVNode("p", null, _toDisplayString(_unref(incomingCallUserDescrList)), 1),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_button, {
                    circle: "",
                    type: "success",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(incomingCall).joinCall()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(FontAwesomeIcon, { icon: "phone" })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    circle: "",
                    type: "danger",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(incomingCall).hangUp()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(FontAwesomeIcon, { icon: "times" })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})